var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isiPhone)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowTop),expression:"isShowTop"}],staticClass:"home-top",style:(_vm.barStyle)},[_vm._m(0),_c('span',{staticClass:"btn",on:{"click":_vm.$openApp}},[_vm._v("打开看看")])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":require("@/assets/icon/logo.png"),"alt":""}}),_vm._v("更多精彩视频，等你来哦")])
}]

export { render, staticRenderFns }